export default {
	init() {
		document.dispatchEvent(new Event('submitMover'))
	}
}
